<template>
  <!-- <ImageSequencePlayer
      imagePattern="/figures/transport/hero/Aerodynamic-4SPP-140Res_frames_161-300_hero.{frame}.png"
      :startFrame="161"
      :endFrame="300"
      :autoPlay="false"
      altText="Interactive image sequence"
    /> -->
    <ImageSequencePlayer
      imagePattern="/figures/transport/rotation_frames_compressed/rotation_{frame}.webp"
      :startFrame="200"
      :endFrame="380"
      :autoPlay="false" 
      :slowAutoPlay="true"
      :slowFrameRate="15" 
      :autoPlayResumeDelay="1000" 
      altText="Interactive image sequence with slow auto-play"
    />
</template>

<script>
import ImageSequencePlayer from './ImageSequencePlayer.vue'

export default {
  name: 'USBSceneTransport',
  components: {
    ImageSequencePlayer
  },
  data () {
    return {
      // stats: null
    }
  },
  mounted () {
  },
  beforeUnmount() {
  },
  methods: {
  },
}
</script>

<style scoped>

</style>